<sew-headline level="4"> {{ 'ELECTRONICS.HEADING' | translate }} </sew-headline>
<p>{{ 'ELECTRONICS.DESCRIPTION' | translate }}</p>
<div class="flex-container">
    @switch (isMobile) {
        @case (false) {
            <sew-search-field class="serial-number" [error]="error ? true : false">
                <ng-container *ngTemplateOutlet="searchContent"></ng-container>
            </sew-search-field>
        }
        @case (true) {
            <sew-input class="serial-number" [status]="error ? 'error' : null">
                <ng-container *ngTemplateOutlet="searchContent"></ng-container>
            </sew-input>
        }
    }
    <ng-template #searchContent>
        <input
            id="serial_number"
            [placeholder]="'ELECTRONICS.SERIALNMUBER_INPUT_PLACEHOLDER' | translate"
            [(ngModel)]="searchValue"
            (ngModelChange)="resetSearchError()"
            type="text"
            autocomplete="off"
            (keydown.enter)="searchElectronics()"
        />
        @if (error) {
            <div>{{ 'ELECTRONICS.ERROR.NO_PRODUCT_FOUND' | translate }}</div>
        }
    </ng-template>
    <sew-button #searchButton class="search" hierarchy="primary" website icon="search">
        <button (click)="searchElectronics()" [disabled]="!searchValue">
            {{ 'ELECTRONICS.SEARCH' | translate }}
        </button>
    </sew-button>
</div>
